import { tv } from "tailwind-variants";

export const sidebarMenuVariants = tv({
  slots: {
    trigger:
      "flex items-center gap-1 p-3 underline-offset-2 hover:underline data-[state=open]:underline",
    item: "flex items-center justify-between gap-4",
    arrowIcon: "h-3 w-6 -translate-y-0.5 fill-neutral-100",
    linkIcon: "size-4 text-primary-600",
  },
});
